module.exports = __webpack_public_path__ + "img/scapp_1@2x.637ed439.png";